module.exports = __webpack_public_path__ + "static/img/delete.be760b89.png";